import "./WellnessServices.module.css";
import Header from "@/reusable_sections/Header";
import TheCityPetCareJourney from "./sections/TheCityPetCareJourney";
import OurSpecializedCare from "./sections/OurSpecializedCare";
import Footer from "@/reusable_sections/Footer";
export default function WellnessServicesPage() {
  return <div>
      <Header />
      <TheCityPetCareJourney />
      <OurSpecializedCare />
      <Footer />
    </div>;
}